import { useAuth0 } from '@auth0/auth0-react';
import styles from './LogoutButton.module.css';

/**
 * LogoutButton Component
 *
 * Displays a logout button that logs out the user from Auth0
 */
function LogoutButton() {
    const { logout } = useAuth0();

    return (
        <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            className={styles.button}
        >
            Log Out
        </button>
    );
}

export default LogoutButton;
